import { ICommunicationPreferences } from '../types';

export const EMPTY_COMMUNICATION_PREFERENCES: ICommunicationPreferences = {
  agreeToTsAndCs: undefined,
  marketingOptIn: undefined,
  guardianConsent: undefined,
  showGuardianConsent: false,
};
